<template>
	<Teleport to="body">
		<transition
			enter-active-class="transition-opacity duration-150 ease-out"
			enter-from-class="opacity-0"
			enter-to-class="opacity-100"
			leave-active-class="transition-opacity duration-100 ease-in"
			leave-from-class="opacity-100"
			leave-to-class="opacity-0">
			<div v-if="isAnyFlyoutOpen" class="cfl-flyout-backdrop"></div>
		</transition>
	</Teleport>
</template>

<script lang="ts" setup>
	import useFlyoutBackdrop from "@shared-composables/useFlyoutBackdrop";

	const { isAnyFlyoutOpen } = useFlyoutBackdrop();
</script>

<style scoped>
	@reference "@main-css";

	.cfl-flyout-backdrop {
		@apply fixed inset-0 z-30 bg-black/40 pointer-events-none;
	}
</style>
